import React from 'react';
import { Text } from '@wix/design-system';
import { usePremiumCurrencyFormatter } from '@wix/premium-react-text';
import { useTranslation } from '../../../hooks/use-translation';
export function PriceBadge({ app }) {
    const t = useTranslation();
    const fixedPrice = app?.appSavedPrice && app?.appSavedPrice !== 0
        ? Number(app?.appSavedPrice).toFixed(2)
        : '';
    const [currencyToString] = usePremiumCurrencyFormatter({
        currencySettings: {
            [app?.webSolutionBase.pricing?.currencySettings?.code]: {
                symbol: app?.webSolutionBase.pricing?.currencySettings?.symbol,
                decimalSep: app?.webSolutionBase.pricing?.currencySettings?.decimalSeparator,
                groupSep: app?.webSolutionBase.pricing?.currencySettings?.groupSeparator,
                negPrefix: app?.webSolutionBase.pricing?.currencySettings?.negativePrefix,
                negSuffix: app?.webSolutionBase.pricing?.currencySettings?.negativeSuffix,
                posPrefix: '¤',
                posSuffix: '',
                fractionSize: 2,
            },
        },
        currencyCode: app?.webSolutionBase.pricing?.currencySettings?.code,
    });
    const savedPrice = currencyToString(Number(fixedPrice));
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        fixedPrice !== '' && (React.createElement("span", { style: { textDecoration: 'line-through' } },
            React.createElement(Text, { size: 'small', weight: 'thin', secondary: true }, savedPrice))),
        React.createElement("span", { style: { marginLeft: '6px' } },
            React.createElement(Text, { size: "small", weight: 'thin', skin: 'success', secondary: true }, t('manage-apps.app-price.free')))));
}
//# sourceMappingURL=price-badge.js.map